import { createBrowserRouter, RouterProvider } from "react-router";
import { Authenticator } from "@aws-amplify/ui-react";
import { type AuthEventData } from "@aws-amplify/ui";
import { Layout } from "./components/Layout";
import { HomePage } from "./pages/HomePage";
import { DocumentsPage } from "./pages/DocumentsPage";
import { DocumentPage } from "./pages/DocumentPage";
import { UsersPage } from "./pages/UsersPage";
import { UserDetailPage } from "./pages/UserDetailPage";
import ControllingPage from "./pages/ControllingPage";
import ReportsPage from "./pages/ReportsPage";
import "./lib/amplify";
import "@aws-amplify/ui-react/styles.css";
import { RecoilRoot } from "recoil";
import { TagsPage } from "./pages/TagsPage";
import { UsagePage } from "./pages/UsagePage";
import { NotFoundPage } from "./pages/NotFoundPage";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

// Create router with signOut function
const createAppRouter = (
    signOut: ((data?: AuthEventData) => void) | undefined,
) =>
    createBrowserRouter([
        {
            path: "/",
            element: <Layout signOut={signOut} />,
            children: [
                {
                    index: true,
                    element: <HomePage />,
                },
                {
                    path: "receipts",
                    element: <DocumentsPage />,
                },
                {
                    path: "receipts/:documentId",
                    element: <DocumentPage />,
                },
                {
                    path: "controlling",
                    element: <ControllingPage />,
                },
                {
                    path: "reports",
                    element: <ReportsPage />,
                },
                {
                    path: "tags",
                    element: <TagsPage />,
                },
                {
                    path: "users",
                    element: <UsersPage />,
                },
                {
                    path: "users/:username",
                    element: <UserDetailPage />,
                },
                {
                    path: "usage",
                    element: <UsagePage />,
                },
                {
                    path: "*",
                    element: <NotFoundPage />,
                },
            ],
        },
    ]);

// Create a client
const queryClient = new QueryClient();

function App() {
    return (
        <Authenticator hideSignUp>
            {({ signOut }) => {
                const router = createAppRouter(signOut);
                return (
                    <div className="min-h-screen">
                        <QueryClientProvider client={queryClient}>
                            <RecoilRoot>
                                <RouterProvider router={router} />
                            </RecoilRoot>
                        </QueryClientProvider>
                    </div>
                );
            }}
        </Authenticator>
    );
}

export default App;
